import { render } from "./MyofficeMain.vue?vue&type=template&id=604d214c&scoped=true"
import script from "./MyofficeMain.vue?vue&type=script&lang=js"
export * from "./MyofficeMain.vue?vue&type=script&lang=js"

import "./MyofficeMain.vue?vue&type=style&index=0&id=604d214c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604d214c"]])

export default __exports__